export default __webpack_public_path__ + "static/media/desert_tree.7de51ad6.png";